import React from 'react'
import icon from '../../../assets/userIcon.png'
interface CustomerDetailsModal{
  customer:any
}
const CustomerDetailsModal = ({customer}:CustomerDetailsModal) => {
  return (
    <div>
      <div>
        <img src={icon} className='my-3' alt="icon" />
        <div className='my-3'>
          <p className='text-xl font-bold'>Transaction Details</p>
          <p className='text-sm'>Kindly find your transaction details below</p>
        </div>
      </div>
    </div>
  )
}

export default CustomerDetailsModal
